import { type_GM_STATE } from '../../helpers'
import { OmneoList, type_WISHLIST_DASHBOARD_STATE } from '../types'
import { openModal } from '../helpers/useModal'
import type { WishlistPage, WishlistPageIds } from './WishlistDashboard'
import { WishlistListRow } from './WishlistListRow'

declare var GM_STATE: type_GM_STATE
declare var wishlistDashboardState: type_WISHLIST_DASHBOARD_STATE

type WishlistListHeaderProps = {
  lists: OmneoList[]
  page: WishlistPage
  pageIds: WishlistPageIds
  setPage: (page: WishlistPage) => void
  showPageTitle: boolean
}

export function WishlistListHeader({ lists, page, pageIds, setPage, showPageTitle }: WishlistListHeaderProps) {
const hasLists = lists.length > 0
const wrapperClassName = hasLists
  ? showPageTitle
    ? 'pt-[60px] pb-5'
    : 'pb-5'
  : showPageTitle
    ? 'pt-[60px] pb-[30px] md:pt-20 md:pb-[45px]'
    : 'pt-[30px] pb-[30px] md:pt-0 md:pb-[45px]'

  return (
    <div className={`bg-background-light px-5 md:text-left text-center ${wrapperClassName}`}>
      {showPageTitle && <h1 className="h2 text-ink uppercase lg-max:text-center">{wishlistDashboardState.dashboard.title}</h1>}
      <div className={`flex items-center justify-center gap-5 ${showPageTitle ? 'mt-[46px] lg:mt-16' : 'mt-0'}`}>
        <button
          className={`text-sm-b font-light font-calibre uppercase border-0 border-b border-solid pb-1 ${page === pageIds.allItems ? 'text-ink border-ink' : 'text-subdued border-transparent'}`}
          onClick={() => setPage(pageIds.allItems)}
        >
          All Items
        </button>
        <button
          className={`text-sm-b font-light font-calibre uppercase border-0 border-b border-solid pb-1 ${page === pageIds.lists ? 'text-ink border-ink' : 'text-subdued border-transparent'}`}
          onClick={() => setPage(pageIds.lists)}
        >
          Wishlists
        </button>
      </div>
    </div>
  )
}

type contentProps = {
  lists: OmneoList[]
  pageIds: WishlistPageIds
  setPage: (page: WishlistPage) => void
  setCurrentList: React.Dispatch<React.SetStateAction<OmneoList>>
}
export function WishlistListContent({ lists, pageIds, setPage, setCurrentList }: contentProps) {
  const openList = (list: OmneoList) => {
    const urlParams = new URL(window.location.href)
    if (urlParams.hash.includes('#view=detail&id=')) {
      urlParams.hash = `#view=detail&id=${list.id.toString()}`
      window.history.pushState({}, '', urlParams)
    } else {
      urlParams.hash = `#view=detail&id=${list.id.toString()}`
      window.history.pushState({}, '', urlParams)
    }

    setCurrentList(list)
    setPage(pageIds.detail)

    if (!sessionStorage.getItem('show-share-private')) {
      setTimeout(() => {
        !list.is_shared && openModal('share-private')
      }, 500)
    }
  }

  const openCreateList = async () => {
    openModal('create-list-slideout')
  }

  const { imageDefault } = GM_STATE.wishlist

  return (
    <div className="relative w-full max-w-full px-5 mx-auto pb-0 min-h-[478px] md:pb-[120px] md:min-h-[516px] md:max-w-[728px]">
      {lists.map((list: OmneoList) => (
        <div className="w-full py-[15px] border-0 border-t border-solid border-secondary md:py-5" key={list.id}>
          <RenderListItem key={list.id} list={list} imageDefault={imageDefault} openList={openList} />
        </div>
      ))}
      <div className={`w-full ${lists.length > 0 ? 'md:text-right py-[15px] border-0 border-t border-solid border-secondary md:py-5' : 'md:text-center'}`}>
        <button className='Button Button--quaternary-dark' onClick={openCreateList}>{wishlistDashboardState.createNewList}</button>
      </div>
    </div>
  )
}

function RenderListItem({
  list,
  imageDefault,
  openList
}: {
  list: OmneoList
  imageDefault: { src: string; alt?: string }
  openList: (list: OmneoList) => void
}) {
  const imageSrc = list.meta?.image?.src || list.items.find((x) => x?.meta?.image?.src)?.meta.image.src || list.items.find((x) => x?.meta?.image)?.meta.image
  const image = {
    src: imageSrc?.toString() || imageDefault.src,
    alt: list.name || imageDefault.alt
  }

  return (
    <WishlistListRow list={list} image={image} onClick={() => openList(list)} />
  )
}
